import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'progressWidth',
})
export class ProgressWidthPipe implements PipeTransform {

  transform(total: number, step: number): progressType {
    const persent: progressType = new progressType();
    persent.stylePersent = `${Math.floor((step / total) * 100)}%`;
    persent.textPersent = `% ${Math.floor((step / total) * 100)}`;
    return persent;
  }
}


export class progressType {
  stylePersent?: string;
  textPersent?: string;
}